export enum CurrencyEnum {
  JPY = 'JPY',
  MXN = 'MXN',
}
